<template>
    <div class="row">
        <div class="col-lg-6">
            <div class="card mb-3">
                <form class="card-body" @submit.prevent="UPDATE_ACCOUNT()">
                    <div>
                        <h5>Detalles personales</h5>
                        <p>Para cambiar tus datos personales, edítalo y guárdalo desde aquí</p>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Correo Electrónico</small>
                                <input type="email" class="form-control form-control-sm" v-model="data.email" :class="errors.email ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.email" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-3">
                                <small class="input-title">Genero</small>
                                <v-select v-model="data.gender"
                                    :items="genders"
                                    hide-details
                                    class="form-control form-control-sm"
                                    :class="errors.gender ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.gender" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <button class="btn btn-success btn-sm">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count_account == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar cambios</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card mb-3">
                <form class="card-body" @submit.prevent="CHANGE_PASSWORD()">
                    <div>
                        <h5>Cambiar la contraseña</h5>
                        <p>Para cambiar su contraseña por favor confirme aquí</p>
                    </div>
                    <div class="form-group mb-3">
                        <small class="input-title">Contraseña Actual</small>
                        <v-text-field v-model="data.password_current"
                            :append-icon="type_current ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="type_current ? 'text' : 'password'" class="form-control" hide-details
                            @click:append="type_current = !type_current"
                            :class="errors.password_current ? 'is-invalid' : ''">
                        </v-text-field>
                        <small class="invalid-feedback" v-for="(error, index) in errors.password_current"
                            :key="index">{{ error }}</small>
                    </div>
                    <div class="form-group mb-3">
                        <small class="input-title">Contraseña Nueva</small>
                        <v-text-field v-model="data.password"
                            :append-icon="type ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="type ? 'text' : 'password'" class="form-control" hide-details
                            @click:append="type = !type"
                            :class="errors.password ? 'is-invalid' : ''">
                        </v-text-field>
                        <small class="invalid-feedback" v-for="(error, index) in errors.password"
                            :key="index">{{ error }}</small>
                    </div>
                    <div class="form-group mb-3">
                        <small class="input-title">Confirmar Contraseña</small>
                        <v-text-field v-model="data.password_confirmation"
                            :append-icon="type_confirm ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="type_confirm ? 'text' : 'password'" class="form-control" hide-details
                            @click:append="type_confirm = !type_confirm"
                            :class="errors.password_confirmation ? 'is-invalid' : ''">
                        </v-text-field>
                        <small class="invalid-feedback" v-for="(error, index) in errors.password_confirmation"
                            :key="index">{{ error }}</small>
                    </div>
                    <div class="form-group mb-3">
                        <input type="checkbox" id="check" v-model="data.closing">
                        <label class="input-title" for="check">Solicitar que todos los dispositivos inicien sesión con la nueva contraseña</label>
                    </div>
                    <div class="form-group">
                        <button class="btn btn-success btn-sm">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count_password == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Guardar contraseña</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-lg-6 mb-3" v-if="miami">
            <div class="card">
                <div class="card-body">                    
                    <div>
                        <h5>Tu dirección en Miami:</h5>
                    </div>          
                    <div class="d-flex align-items-center"><i class="bi bi-people me-2 text-muted"></i> <span class="text-sm text-heading text-primary-hover">{{ data.name + ' ' + data.type + data.id }}</span></div>
                    <div class="d-flex align-items-center"><i class="bi bi-geo-alt me-2 text-muted"></i> <span class="text-sm text-heading text-primary-hover" v-html="miami.address"></span></div>
                    <div class="d-flex align-items-center"><i class="bi bi-telephone me-2 text-muted"></i> <span class="text-sm text-heading text-primary-hover">{{ miami.phone }}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'user',
            'accounts',
        ])
    },
    data () {
        return {
            data: {},
            errors: {},
            genders: [
                { value: null, text: 'Otro' },
                { value: 0, text: 'Masculino' },
                { value: 1, text: 'Femenino' },
            ],
            miami: {},
            count_account: 0,
            count_password: 0,
            option: 0,
            type_current: false,
            type: false,
            type_confirm: false,
        }
    },
    created () {
        let vue = this
        vue.data = vue.user
        axios({ url: '/miami', method: 'GET' })
            .then((resp) => {
                vue.miami = resp.data
            })
    },
    methods: {
        UPDATE_ACCOUNT: function(){
            let vue = this
            vue.count_account++
            if(vue.count_account == 1){
                vue.errors = {}
                let data = {
                    email: vue.data.email,
                    gender: vue.data.gender,
                    option: 1
                }
                setTimeout(() => {
                    axios({url: '/me', method: 'POST', data: data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$store.dispatch('PROFILE', resp.data.data)
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count_account = 0
                    })
                }, 1000)
            }
        },
        CHANGE_PASSWORD: function(){
            let vue = this
            vue.count_password++
            if(vue.count_password == 1){
                vue.errors = {}
                let data = {
                    password_current: vue.data.password_current,
                    password: vue.data.password,
                    password_confirmation: vue.data.password_confirmation,
                    closing: vue.data.closing,
                    option: 4
                }
                setTimeout(() => {
                    axios({url: '/me', method: 'POST', data: data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        if(vue.data.closing){
                            vue.$store.dispatch('FINISH_USER')
                            vue.$router.push({ name: 'Login' })
                        }
                        vue.data.password_current = ''
                        vue.data.password = ''
                        vue.data.password_confirmation = ''
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count_password = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>